import { Component} from '@angular/core';

@Component({
  selector: 'app-batch-download',
  templateUrl: './batch-download.component.html',
  styleUrls: ['./batch-download.component.css']
})
export class BatchDownloadComponent {
}
